import React from 'react';

import ResearchTeaser from './Teaser';
import ResearchDetail from './Detail';

const NodeResearch = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <ResearchTeaser {...props} />;
  }

  return <ResearchDetail {...props} />;
};

export default NodeResearch;
